var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "music-player" }, [
    _c(
      "div",
      { staticClass: "music-player-body" },
      [
        _c(
          "div",
          { staticClass: "music-player-title" },
          [_c("MusicPlayerMarquee", { attrs: { text: _vm.title } })],
          1
        ),
        _vm._v(" "),
        _c("i-tag-list", {
          staticClass: "music-player-category",
          attrs: { tags: _vm.category },
          on: { click: _vm.onAudioEnded },
        }),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "music-player-controls" },
          [
            _c("i", {
              staticClass: "isif",
              class: _vm.detectMainBtnCssClass(),
              on: { click: _vm.onMainBtnClick },
            }),
            _vm._v(" "),
            _c("MusicPlayerProgress", {
              attrs: { max: _vm.duration },
              on: { seek: _vm.onSeek, seeked: _vm.onSeeked },
              model: {
                value: _vm.currentTime,
                callback: function ($$v) {
                  _vm.currentTime = $$v
                },
                expression: "currentTime",
              },
            }),
            _vm._v(" "),
            _c("span", { staticClass: "music-player-time" }, [
              _vm._v(_vm._s(_vm.countdown)),
            ]),
          ],
          1
        ),
      ],
      1
    ),
    _vm._v(" "),
    _c("div", { staticClass: "music-player-close" }, [
      _c("i", { staticClass: "isif isif-close", on: { click: _vm.stop } }),
    ]),
    _vm._v(" "),
    _c("audio", {
      ref: "audioRef",
      attrs: { loop: _vm.loop },
      on: {
        canplay: _vm.onAudioCanPlay,
        timeupdate: _vm.onAudioTimeUpdate,
        playing: _vm.onAudioPlaying,
        waiting: _vm.onAudioWaiting,
        pause: _vm.onAudioPause,
        ended: _vm.onAudioEnded,
      },
    }),
    _vm._v(" "),
    _vm.disabled
      ? _c("div", { staticClass: "music-play-disable-mask" })
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }